module.exports = __webpack_public_path__ + "static/img/u72270.bb7a4a7c.png";